//
//
//
//
//
//
//
//
//
//
//
//
//

import {base} from '../../common/mixins'

export default {
  name: 'Checkbox',
  mixins: [base],
  props: {
    option: {
      // .sync 单个配置对象
      type: Object,
      default: () => ({
        label: {
          // 显示的文本
          type: String,
          default: null,
        },
        value: {
          // 复选框的值
          type: null,
          default: null,
        },
        checked: {
          // 是否选中
          type: Boolean,
          default: false,
        },
        disabled: {
          // 是否禁用
          type: Boolean,
          default: false,
        },
      }),
    },
  },
  data () {
    return {
      inputValue: this.option.checked,
    }
  },
  watch: {
    inputValue (value) {
      if(value !== this.option.checked) {
        const newOption = {...this.option, checked: value}
        this.emitChange(newOption)
      }
    },
  },
  mounted () {
    this.$watch(() => this.option.checked, () => {
      this.inputValue = this.option.checked
    })
    this.emitChange(this.option)
  },
  methods: {
    // 抛出 change 事件
    emitChange (option) {
      this.$emit('update:option', option)
      this.$emit('change', option.value, option)
    },

    // handle
    inputClick () {
      if(!this.option._disabled && !this.option.disabled) {
        this.inputValue = !this.inputValue
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Check/Checkbox.vue